/* GLORY DEPT. — gd-cart.js
   The cart drawer + add-to-cart are handled by Horizon's own components
   (kept intact by design). This module only layers brand micro-behaviour:
   re-applies image fade-in to nodes injected into the cart drawer so
   dynamically-rendered line items match the rest of the site. */
(function () {
  'use strict';
  if (!('MutationObserver' in window)) return;

  function fade(scope) {
    scope.querySelectorAll && scope.querySelectorAll('img:not(.gd-loaded)').forEach(function (img) {
      if (img.complete) img.classList.add('gd-loaded');
      else img.addEventListener('load', function () { img.classList.add('gd-loaded'); }, { once: true });
    });
  }

  function watch() {
    var drawer = document.querySelector('cart-drawer-component, .cart-drawer, #cart-drawer');
    if (!drawer) return;
    var mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) fade(n); }); });
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
